// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 143) return "app-v2-8becc7b5.css";
	// return url for filenames based on template
	return "" + ({"271":"playground","519":"canvas"}[chunkId] || chunkId) + "-v2-" + {"14":"f9f6b12d","271":"7f409e49","519":"7f409e49","841":"f9f6b12d"}[chunkId] + ".chunk.css";
};